import { createFileRoute } from "@tanstack/react-router";
import {
  ScaffoldSection,
  ScaffoldSectionContainer,
  ScaffoldSectionContent,
  ScaffoldSectionHeader,
  ScaffoldSectionTitle,
} from "@/components/www/sections/scaffold";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/_www/impressum")({
  component: RouteComponent,
  head: () =>
    seo({
      title: "Impressum – Alte Papierfabrik Wuppertal",
      description:
        "Impressum der Alten Papierfabrik Wuppertal – Kontaktdaten und rechtliche Informationen.",
      path: "/impressum",
    }),
});

function RouteComponent() {
  return (
    <ScaffoldSection className="md:pt-24">
      <ScaffoldSectionContainer>
        <ScaffoldSectionHeader>
          <ScaffoldSectionTitle>Impressum</ScaffoldSectionTitle>
        </ScaffoldSectionHeader>
        <ScaffoldSectionContent>
          <section className="prose prose-invert max-w-full px-4">
            <h3>Angaben gemäß § 5 TMG:</h3>
            <p>
              TOMA 1807 GmbH &amp; Co KG
              <br />
              ALTE PAPIERFABRIK DIE EVENT - LOCATION IN WUPPERTAL
              <br /> Friedrich-Ebert-Str. 130
              <br /> 42117 Wuppertal
            </p>
            <h3>Vertreten durch:</h3>
            <p>Geschäftsführer: Sarafim Mitrakis</p>
            <h3>Kontakt:</h3>
            <table>
              <tbody>
                <tr>
                  <td>Telefon:</td>
                  <td>0202 / 3179995</td>
                </tr>
                <tr>
                  <td>E-Mail:</td>
                  <td>
                    <span className="cloaked_email">
                      info@altepapierfabrik.eu
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <h3>Registereintrag:</h3>
            <p>
              Eintragung im Handelsregister. <br />
              Registergericht: Wuppertal <br />
              Registernummer: HRA 22459
            </p>
            <h3>Umsatzsteuer-ID:</h3>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
              DE 257975583
            </p>
            <h3>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</h3>
            <p>
              Sarafim Mitrakis
              <br /> Friedrich - Ebert - Str. 130 42117 Wuppertal
            </p>
            <h3>Hinweis auf EU-Streitschlichtung</h3>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a href="http://ec.europa.eu/consumers/odr">
                http://ec.europa.eu/consumers/odr
              </a>
              <br /> Unsere E-Mail-Adresse finden sie oben im Impressum.
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>
              <strong>
                Haftungsausschluss für das Webangebot der Alten Papierfabrik.
              </strong>
            </p>
            <p>
              <strong>Inhalt des Webangebotes</strong>
              <br />
              Die Alte Papierfabrik ist bemüht, das Webangebot stets aktuell und
              inhaltlich richtig sowie vollständig anzubieten. Dennoch ist das
              Auftreten von Fehlern nicht völlig auszuschließen. Die Alte
              Papierfabrik übernimmt keine Haftung für die Aktualität, die
              inhaltliche Richtigkeit sowie für die Vollständigkeit der in ihrem
              Webangebot eingestellten Informationen, es sei denn; die Fehler
              wurden vorsätzlich oder grob fahrlässig aufgenommen. Dies bezieht
              sich auf eventuelle Schäden materieller oder ideeller Art Dritter,
              die durch die Nutzung dieses Webangebotes verursacht wurden.
            </p>
            <p>
              <strong>Copyright</strong>
              <br />
              Das Layout der Homepage, die verwendeten Grafiken und Bilder, die
              Sammlung sowie einzelne Beiträge sind urheberrechtlich geschützt.
              Alle Rechte, auch die der fotomechanischen Wiedergabe, der
              Vervielfältigung und der Verbreitung mittels besonderer Verfahren
              (zum Beispiel Datenverarbeitung, Datenträger und Datennetze), auch
              teilweise, behält sich die Alte Papierfabrik vor.
            </p>
            <p>
              <strong>Externe Verweise und Links</strong>
              <br />
              Mit Urteil vom 12. Mai 1998 hat das LG Hamburg entschieden, dass
              man durch die Ausbringung von Links die Inhalte der gelinkten
              Seite ggf. mit zu verantworten hat. Dies kann, so das LG, nur
              dadurch verhindert werden, dass man sich ausdrücklich von diesen
              Inhalten distanziert. Wir haben auf unseren Seiten Links zu Seiten
              im Internet gelegt, deren Inhalt und Aktualisierung nicht dem
              Einflussbereich der Alte Papierfabrik unterliegen. Für alle diese
              Links gilt: "Die Alte Papierfabrik hat keinen Einfluss auf
              Gestaltung und Inhalte fremder Internetseiten. Sie distanziert
              sich daher von allen fremden Inhalten, auch wenn von den Webseiten
              der Alte Papierfabrik auf diese externen Seiten ein Link gesetzt
              wurde." Dies Erklärung gilt für alle auf unserer Homepage
              angezeigten Links und für alle Inhalte der Seiten, zu denen die
              bei uns angemeldeten Banner und Links führen.
            </p>
            <p>
              <strong>Rechtswirksamkeit</strong>
              <br />
              Dieser Haftungsausschluss ist Teil des Internetangebotes der Alte
              Papierfabrik. Sofern einzelne Formulierungen oder Teile dieses
              Textes der geltenden Rechtslage nicht mehr oder nicht mehr
              vollständig entsprechen, bleiben die übrigen Teile dieser
              Erklärung davon unberührt.
            </p>
          </section>
        </ScaffoldSectionContent>
      </ScaffoldSectionContainer>
    </ScaffoldSection>
  );
}
